// Paragraph.jsx
import React from "react";
import PropTypes from "prop-types";
import { useEffect } from "react";
import Editor from "../../Editor/Editor";
import { USERROLE } from "../../../utils/commonConstant";

const Paragraph = ({
  comments,
  trackChangesComments,
  border,
  text,
  color,
  backgroundColor,
  fontSize,
  padding,
  height,
  width,
  elementId,
  inlineFields,
  elementProps,
  onTextChange,
  onEditorInlineFieldsChange,
  selectedElementId,
  formPreview = false,
  trackChangeDisplayBy = USERROLE.ADMIN,
  trackHistorys,
  isShowTrackHistory=false,
  isPresentMode,
}) => {
  return (
    <>
      <Editor
        comments={comments}
        trackChangesComments={trackChangesComments}
        trackHistorys={trackHistorys}
        border={border}
        menuBar={border ? true : false}
        editable={border ? true : false}
        formPreview={formPreview}
        text={text}
        elementId={elementId}
        backgroundColor={backgroundColor}
        existingInlineFields={inlineFields}
        elementProps={elementProps}
        onTextChange={(value, comments, trackChangesComments, forceSave,trackHistorys) => {

            onTextChange(value, comments, trackChangesComments, forceSave,trackHistorys);
        }}
        onEditorInlineFieldsChange={onEditorInlineFieldsChange}
        selectedElementId={selectedElementId}
        trackChangeDisplayBy={trackChangeDisplayBy}
        isShowTrackHistory={isShowTrackHistory}
        isPresentMode={isPresentMode}
      />
    </>
  );
};

Paragraph.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.string,
  padding: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Paragraph;
